// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ge-a";
export var fulfillmentFormRail = "_ge-9";
export var headerTitleRow = "_ge-c";
export var orderDetailsWrapper = "_ge-7";
export var orderLinkTrigger = "_ge-2";
export var paymentInformationGrid = "_ge-h";
export var paymentSummaryColumn = "_ge-i";
export var shipmentContainer = "_ge-b";
export var shipmentDetailsMainPane = "_ge-8";
export var shipmentNavigationCard = "_ge-5";
export var shipmentNavigationRail = "_ge-3";
export var shipmentNavigationRailHeader = "_ge-4";
export var shipmentSummaryFact = "_ge-e";
export var shipmentSummaryGrid = "_ge-d";
export var shipmentSummaryMetadataRow = "_ge-f";
export var shipmentSummaryTags = "_ge-g";
export var shipmentWorkspace = "_ge-0";
export var shipmentWorkspaceContent = "_ge-6";
export var shipmentWorkspaceHeader = "_ge-1";